let androidPort = 0;
let hasInitialized = false;

const ANDROID_READY_MESSAGE = "Android ready";
export const ANDROID_BRIDGE_READY_EVENT = "android-bridge-ready";

function parseAndroidMessage(data) {
  if (typeof data !== "string") return data;

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
}

function isAndroidReadyMessage(message) {
  if (message === ANDROID_READY_MESSAGE) return true;

  return (
    message?.type === "event" &&
    message?.data?.message === ANDROID_READY_MESSAGE
  );
}

function handleAndroidReady(event) {
  const message = parseAndroidMessage(event.data);

  if (message?.type !== "event" && message !== ANDROID_READY_MESSAGE) {
    return;
  }

  if (!isAndroidReadyMessage(message)) {
    return;
  }

  const [messagePort] = event.ports || [];
  if (!messagePort) {
    console.log(
      "Handshake failed: Android ready received without MessagePort.",
    );
    return;
  }

  androidPort = messagePort;

  if (typeof androidPort.start === "function") {
    androidPort.start();
  }

  console.log("Handshake success: androidPort connected.");
  window.dispatchEvent(new CustomEvent(ANDROID_BRIDGE_READY_EVENT));
}

export function initAndroidBridge() {
  if (typeof window === "undefined") return;

  if (hasInitialized) {
    return;
  }

  hasInitialized = true;
  window.addEventListener("message", handleAndroidReady);

  if (typeof document !== "undefined") {
    document.addEventListener("message", handleAndroidReady);
  }
}

export function isAndroidWebView() {
  return Boolean(androidPort);
}

export function isAndroidUserAgent() {
  if (typeof navigator === "undefined") return false;

  return /Android/i.test(navigator.userAgent || "");
}

export function isAndroidEnvironment() {
  return isAndroidWebView();
}

export function sendToAndroid(message) {
  const payload =
    typeof message === "string" ? message : JSON.stringify(message);

  try {
    if (androidPort) {
      androidPort.postMessage(payload);
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
}
